'use client'

import React, {useState} from 'react'
import iconMenu from '@/src/shared/assets/media/icon-menu.svg'
import iconSearch from '@/src/shared/assets/media/icon-search.svg'

import {Collapse} from 'antd'
import {ChevronDown, ChevronRight} from 'lucide-react'
import {Image} from '@/src/shared/ui/image'
import {Routes} from '../../config/routes'
import {Link} from '../../shared/ui/link'

import * as UI from './deep-menu-mobile.styled'
import * as HeaderUI from '@/src/shared/ui/layout/ui/header/header.styles'

interface DeepMenuMobileProps {
  catalog: HeaderCatalogSection[]
}

export const DeepMenuMobile: React.FC<DeepMenuMobileProps> = ({catalog}) => {
  if (catalog.length > 0) {
    return (
      <CatalogCollapseItem
        // @ts-ignore
        as={Collapse}
        items={[
          {
            id: 'catalog-root',
            name: 'Каталог',
            code: 'catalog-root',
            path: Routes.catalog.page,
            images: [],
            children: catalog,
          },
        ]}
      />
    )
  }

  return null
}

type Props = {
  items: HeaderCatalogSection[]
  level?: number
}

export const CatalogCollapseItem = ({items, level = 0}: Props) => {
  const [activeKey, setActiveKey] = useState<string | null>(null)

  return (
    <UI.CatalogCollapseItem
      as={Collapse}
      activeKey={activeKey ?? []}
      $level={level}
      expandIcon={() => null}
      items={items.map(section => ({
        label: (level == 0 && (
          <UI.CatalogRootButton
            onClick={() =>
              setActiveKey(
                activeKey === `${level}-${section.code}` ? null : `${level}-${section.code}`,
              )
            }>
            <HeaderUI.Icon title="Каталог">
              <UI.CatalogIconMenu src={iconMenu} width={17} height={15} alt="" />
              <UI.CatalogIconSearch src={iconSearch} width={10} height={10} alt="" />
            </HeaderUI.Icon>
            <span>Каталог</span>
          </UI.CatalogRootButton>
        )) || (
          <CatalogSection
            level={level}
            section={section}
            active={activeKey === `${level}-${section.code}`}
            onExpand={active =>
              section.children.length > 0
                ? setActiveKey(active ? `${level}-${section.code}` : null)
                : undefined
            }
            root={section.children.length > 0}
          />
        ),
        key: `${level}-${section.code}`,
        children:
          section.children.length > 0 ? (
            <>
              {section.children.length > 1 && (
                <UI.AllSectionLink
                  as={Link}
                  href={
                    level == 0 ? Routes.catalog.page : Routes.catalog.section.page(section.path)
                  }
                  $level={level}>
                  Все категории
                </UI.AllSectionLink>
              )}

              <CatalogCollapseItem items={section.children} level={level + 1} />
            </>
          ) : undefined,
      }))}>
      {/*<div*/}
      {/*  onClick={() => hasChildren && setIsOpen(prev => !prev)}*/}
      {/*  style={{*/}
      {/*    cursor: hasChildren ? 'pointer' : 'default',*/}
      {/*    display: 'flex',*/}
      {/*    justifyContent: 'space-between',*/}
      {/*    padding: '8px 0',*/}
      {/*  }}>*/}
      {/*  <span>{item.name}</span>*/}
      {/*  {hasChildren && <span>{isOpen ? '−' : '+'}</span>}*/}
      {/*</div>*/}

      {/*{hasChildren && isOpen && (*/}
      {/*  <div>*/}
      {/*    {item.children.map(child => (*/}
      {/*      <CatalogCollapseItem key={child.id} item={child} level={level + 1} />*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*)}*/}
    </UI.CatalogCollapseItem>
  )
}

interface CatalogSectionProps {
  section: HeaderCatalogSection
  active: boolean
  onExpand(active: boolean): void
  level: number
  root: boolean
}

const CatalogSection = ({section, active, onExpand, level, root}: CatalogSectionProps) => {
  return (
    <UI.CatalogSection onClick={() => onExpand(!active)} $level={level}>
      <UI.CatalogSectionName>
        {section.images.length > 0 && (
          <UI.CatalogSectionImage>
            <Image width={40} height={40} src={section.images[0]!} />
          </UI.CatalogSectionImage>
        )}
        <UI.SectionLink
          as={section.children.length == 0 ? Link : undefined}
          // @ts-ignore
          href={Routes.catalog.section.page(section.path)}
          $level={level}
          $root={root}>
          {section.name}
        </UI.SectionLink>
      </UI.CatalogSectionName>
      {section.children.length > 0 && (
        <UI.ExpandIcon as={!active ? ChevronRight : ChevronDown} size={16} />
      )}
    </UI.CatalogSection>
  )
}
